/* eslint-disable react/display-name */
import {
  Button,
  Col,
  ContentBody,
  ContentHeader,
  Drawer,
  Input,
  RangeDatePicker,
  Row,
  Table
} from '../../core/components'
import { Link } from 'react-router-dom'
import { routesConfig } from '../../core/configs/routes'
import { FilterOutlined, PlusOutlined } from '@ant-design/icons'
import { dateTimeFormat } from '../../utils/format/dateTimeFormat'
import { ChangeEvent, useEffect, useMemo, useState } from 'react'
import { CustomerType, OpportunityFilter, Pagination } from '../../entities'
import useServiceOrders from '../../services/queries/serviceOrders/useServiceOrders'

const filterDefaultValue = {
  search: '',
  concept: '',
  event: '',
  createdAt: {
    startDate: '',
    endDate: ''
  }
}

export const ServiceOrderPage = () => {
  const [pagination, setPagination] = useState<Pagination>({
    page: 1,
    limit: 10
  })
  const [showFilter, setShowFilter] = useState<boolean>(false)

  const [filters, setFilters] = useState<OpportunityFilter>(filterDefaultValue)
  const [filterState, setFilterState] =
    useState<OpportunityFilter>(filterDefaultValue)

  const { serviceOrders, serviceOrdersLoading, isFetching, isPreviousData } =
    useServiceOrders({
      ...pagination,
      filters
    })

  const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
    setFilterState((prev: OpportunityFilter) => ({
      ...prev,
      search: e.target.value.toUpperCase()
    }))
  }

  const handlePagination = (page: number, limit: number) => {
    setPagination({ page, limit })
  }

  const handleReset = () => {
    setFilterState(filterDefaultValue)
    setFilters(filterDefaultValue)
  }

  useEffect(() => {
    if (filterState.search === '')
      setFilters((prev) => ({ ...prev, search: '' }))
  }, [filterState.search])

  const columns = useMemo(
    () => [
      {
        title: 'Nº Ordem de Serviço',
        dataIndex: 'id',
        key: 'id',
        render: (value: any, row: any) => {
          return (
            <Link
              to={
                routesConfig.ordersOfService.serviceOrder.details +
                `/${row.id}/detalhes`
              }
            >
              {value}
            </Link>
          )
        }
      },
      {
        title: 'Cliente',
        dataIndex: 'customer',
        render: (value: CustomerType) => (value ? value.name : '')
      },
      {
        title: 'Produto',
        dataIndex: 'item',
        render: (value: any) => value.name
      },
      {
        title: 'Data/Hora',
        dataIndex: 'date',
        key: 'date',
        render: (value: string) => (value ? dateTimeFormat(value) : null)
      }
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  const handleShowFilter = () => {
    setShowFilter((prev: boolean) => !prev)
  }

  const handleClear = (key: string) => {
    setFilters((prev) => ({ ...prev, [key]: '' }))
    setFilterState((prev) => ({ ...prev, [key]: '' }))
  }

  const handleDateClear = () => {
    console.log('clearDate')
    setFilters((prev) => ({
      ...prev,
      createdAt: { startDate: '', endDate: '' }
    }))
    setFilterState((prev) => ({
      ...prev,
      createdAt: { startDate: '', endDate: '' }
    }))
  }
  return (
    <>
      <ContentHeader>Ordens de Serviço</ContentHeader>
      <ContentBody>
        <Row style={{ marginBottom: 10 }}>
          <Col>
            <Input
              allowClear
              value={filterState.search}
              placeholder="Pesquisar cliente ..."
              style={{ width: '385px', marginBottom: 20 }}
              onChange={(e) => handleSearch(e)}
              onPressEnter={() => setFilters(filterState)}
            />
          </Col>
          <Col>
            <Button
              htmlType="submit"
              type="primary"
              style={{ width: 100, marginLeft: 20 }}
              onClick={() => setFilters(filterState)}
            >
              Procurar
            </Button>
            <Button style={{ marginLeft: 10 }} onClick={handleReset}>
              Reiniciar
            </Button>
            <Button
              style={{ marginLeft: 10 }}
              onClick={handleShowFilter}
              icon={<FilterOutlined />}
            >
              Filtros
            </Button>
          </Col>
        </Row>
        <Table
          loading={(serviceOrdersLoading || isFetching) && isPreviousData}
          dataSource={serviceOrders?.data}
          columns={columns}
          pagination={{
            pageSize: pagination.limit,
            current: pagination.page,
            total: serviceOrders?.total,
            onChange: (page, limit) => handlePagination(page, limit || 10)
          }}
          // onChange={handleTableChange}
          bordered
          rowKey={(row) => row.id + row.item.id}
        />
        <Drawer
          title="Filtros"
          width={520}
          closable={false}
          onClose={handleShowFilter}
          visible={showFilter}
          footer={
            <div
              style={{
                textAlign: 'right',
                paddingBottom: 30,
                paddingTop: 30
              }}
            >
              <Button
                onClick={() => {
                  handleReset()
                  handleShowFilter()
                }}
                style={{ marginRight: 8 }}
              >
                Reiniciar
              </Button>
              <Button
                onClick={() => {
                  setFilters(filterState)
                  handleShowFilter()
                }}
                type="primary"
              >
                Aplicar
              </Button>
            </div>
          }
        >
          <Row>
            <Col span={24}>
              <RangeDatePicker
                label="Data Realização"
                format={'DD/MM/YYYY'}
                // onOk={onOk}
                allowClear
                placeholder={['Data Inicial', 'Data Final']}
                onClear={handleDateClear}
                onChange={(e: any) => {
                  if (!e) handleDateClear()
                  setFilterState((prev) => ({
                    ...prev,
                    createdAt: {
                      startDate: e?.[0] || '',
                      endDate: e?.[1] || ''
                    }
                  }))
                }}
              />
            </Col>
          </Row>
        </Drawer>
      </ContentBody>
    </>
  )
}
